/**
 * @generated SignedSource<<adaae0252a47db31895b5981a1bc4836>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type TeamMemberInvitationSort = "ID" | "EXTERNAL_REF" | "ACCOUNT_ID" | "MEMBER_USER_ID" | "EMAIL" | "MESSAGE" | "TOKEN" | "ACCEPTED" | "EXPIRES" | "CREATED_BY" | "DELETED_AT" | "CREATED_AT" | "RANDOM" | "%future added value";
export type TeamMemberInvitationFilter = {
  search?: string | null;
  where?: TeamMemberInvitationWhere | null;
};
export type TeamMemberInvitationWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  accountId?: IDFilter | null;
  memberUserId?: IDFilter | null;
  email?: StringFilter | null;
  message?: StringFilter | null;
  token?: StringFilter | null;
  accepted?: BooleanFilter | null;
  expires?: TimeFilter | null;
  createdBy?: IDFilter | null;
  deletedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  or?: TeamMemberInvitationWhere | null;
  and?: TeamMemberInvitationWhere | null;
};
export type IDFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: string | null;
  notEqualTo?: string | null;
  in?: ReadonlyArray<string> | null;
  notIn?: ReadonlyArray<string> | null;
};
export type StringFilter = {
  isNullOrEmpty?: boolean | null;
  isEmpty?: boolean | null;
  isNull?: boolean | null;
  notNullOrEmpty?: boolean | null;
  notEmpty?: boolean | null;
  notNull?: boolean | null;
  equalTo?: string | null;
  notEqualTo?: string | null;
  in?: ReadonlyArray<string> | null;
  notIn?: ReadonlyArray<string> | null;
  startWith?: string | null;
  notStartWith?: string | null;
  endWith?: string | null;
  notEndWith?: string | null;
  contain?: string | null;
  notContain?: string | null;
  startWithStrict?: string | null;
  notStartWithStrict?: string | null;
  endWithStrict?: string | null;
  notEndWithStrict?: string | null;
  containStrict?: string | null;
  notContainStrict?: string | null;
};
export type BooleanFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: boolean | null;
  notEqualTo?: boolean | null;
};
export type TimeFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: any | null;
  notEqualTo?: any | null;
  lessThan?: any | null;
  lessThanOrEqualTo?: any | null;
  moreThan?: any | null;
  moreThanOrEqualTo?: any | null;
};
export type TeamMemberInvitationOrdering = {
  sort: TeamMemberInvitationSort;
  direction: SortDirection;
};
export type TeamMemberInvitationsRefetchQuery$variables = {
  after?: string | null;
  filter?: TeamMemberInvitationFilter | null;
  first: number;
  ordering?: ReadonlyArray<TeamMemberInvitationOrdering> | null;
  skip: boolean;
};
export type TeamMemberInvitationsRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"teamMemberInvitationsPaginationFragment">;
};
export type TeamMemberInvitationsRefetchQuery = {
  variables: TeamMemberInvitationsRefetchQuery$variables;
  response: TeamMemberInvitationsRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ordering"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "ordering",
    "variableName": "ordering"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  },
  (v2/*: any*/)
],
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamMemberInvitationsRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "teamMemberInvitationsPaginationFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamMemberInvitationsRefetchQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "TeamMemberInvitationConnection",
            "kind": "LinkedField",
            "name": "teamMemberInvitations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMemberInvitationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMemberInvitation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Account",
                        "kind": "LinkedField",
                        "name": "account",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "platformAccess",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "memberUserId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "memberUserProfile",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accepted",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "createdByUserProfile",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "filters": [
              "filter",
              "ordering"
            ],
            "handle": "connection",
            "key": "TeamMemberInvitationsPaginationFragment_teamMemberInvitations",
            "kind": "LinkedHandle",
            "name": "teamMemberInvitations"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b4c01f371adfd5bf31418be26172ecca",
    "id": null,
    "metadata": {},
    "name": "TeamMemberInvitationsRefetchQuery",
    "operationKind": "query",
    "text": "query TeamMemberInvitationsRefetchQuery(\n  $after: String\n  $filter: TeamMemberInvitationFilter\n  $first: Int!\n  $ordering: [TeamMemberInvitationOrdering!]\n  $skip: Boolean!\n) {\n  ...teamMemberInvitationsPaginationFragment\n}\n\nfragment accountBaseFragment on Account {\n  id\n  externalRef\n  name\n  platformAccess\n  createdAt\n}\n\nfragment teamMemberInvitationFragment on TeamMemberInvitation {\n  id\n  externalRef\n  accountId\n  account {\n    ...accountBaseFragment\n    id\n  }\n  memberUserId\n  memberUserProfile {\n    ...teamMemberUserProfileFragment\n    id\n  }\n  email\n  message\n  accepted\n  createdAt\n  createdByUserProfile {\n    ...teamMemberUserProfileFragment\n    id\n  }\n}\n\nfragment teamMemberInvitationsPaginationFragment on Query {\n  teamMemberInvitations(first: $first, after: $after, filter: $filter, ordering: $ordering) @skip(if: $skip) {\n    count\n    edges {\n      node {\n        ...teamMemberInvitationFragment\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment teamMemberUserProfileFragment on UserProfile {\n  firstName\n  lastName\n}\n"
  }
};
})();

(node as any).hash = "43b8a76004e9a20c89df3a23a9cf08b3";

export default node;
